<script setup lang="ts">
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const props = withDefaults(defineProps<{
    open: boolean;
    title: string;
    description: string;
    confirmLabel?: string;
    cancelLabel?: string;
    destructive?: boolean;
    loading?: boolean;
    keepOpenOnConfirm?: boolean;
}>(), {
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
    destructive: false,
    loading: false,
    keepOpenOnConfirm: false,
});

const emit = defineEmits<{
    'update:open': [value: boolean];
    confirm: [];
}>();
</script>

<template>
    <AlertDialog :open="open" @update:open="emit('update:open', $event)">
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ title }}</AlertDialogTitle>
                <AlertDialogDescription>{{ description }}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel :disabled="loading">{{ cancelLabel }}</AlertDialogCancel>
                <Button
                    v-if="keepOpenOnConfirm"
                    :disabled="loading"
                    :class="cn(destructive && 'bg-destructive text-destructive-foreground hover:bg-destructive/90')"
                    @click="emit('confirm')"
                >
                    {{ loading ? 'Please wait…' : confirmLabel }}
                </Button>
                <AlertDialogAction
                    v-else
                    :disabled="loading"
                    :class="cn(destructive && 'bg-destructive text-destructive-foreground hover:bg-destructive/90')"
                    @click.prevent="emit('confirm')"
                >
                    {{ loading ? 'Please wait…' : confirmLabel }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
